import { DataAwareResponse, DocumentTemplate } from "@/types/types";
import { axiosInstance } from "@helpers/axios-instance";
import { useQueryWithValidation } from "./useQueryWithValidation";

export function useDocumentTemplate(id: string | null) {
  return useQueryWithValidation({
    queryKey: ["template", String(id)],
    queryFn: async () => {

      const { data } = await axiosInstance({
        method: "GET",
        url:  `DocumentTemplate/Get/${id}`,
      });

      return data as DataAwareResponse<DocumentTemplate>;
    },
    enabled: !!id,
  });
}
